module.exports = {"522623100":"城关镇","522623101":"杨柳塘镇","522623102":"双井镇","522623103":"牛大场镇","522623104":"马号镇","522623200":"白垛乡","522623201":"甘溪乡","522623203":"马溪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522623.json
// module id = 2324
// module chunks = 0